import Tone from 'tone';

export default (time, subdevision='8n', amount=1) => Tone.Time(time)
                  .quantize(subdevision, amount).toNotation();



// WEBPACK FOOTER //
// ./src/lib/quantizeTime.js